import { Injectable, computed, signal } from '@angular/core';

/**
 * Tracks the number of outstanding HTTP requests so the global loader
 * (see `loadingInterceptor`) can be shown/hidden application-wide.
 *
 * A counter — rather than a boolean — is required because multiple API
 * calls can be in flight at once; the loader must stay visible until the
 * last one finishes.
 */
@Injectable({ providedIn: 'root' })
export class LoaderService {
  private readonly outstandingRequestCount = signal(0);

  readonly isLoading = computed(() => this.outstandingRequestCount() > 0);

  show(): void {
    this.outstandingRequestCount.update(count => count + 1);
  }

  hide(): void {
    this.outstandingRequestCount.update(count => Math.max(0, count - 1));
  }
}
